const favoritLotAdd = `
  mutation($lotId: ID!) {
    result: favoritLotAdd(lotId: $lotId) {
      errors {
        path
        text
      }
    }
  }
`

const favoritUserAdd = `
  mutation($userId: ID!) {
    result: favoritUserAdd(userId: $userId) {
      errors {
        path
        text
      }
    }
  }
`

const favoritLotRemove = `
  mutation($lotId: ID!) {
    result: favoritLotRemove(lotId: $lotId) {
      errors {
        path
        text
      }
    }
  }
`

const favoritUserRemove = `
  mutation($userId: ID!) {
    result: favoritUserRemove(userId: $userId) {
      errors {
        path
        text
      }
    }
  }
`

const fetchFavoritsLots = `
  query ($type: FavoritTypeTypeEnum){
    result: me {
      favorits (type: $type) {
        favoritable {
          ... on Lot {
            id
            name
            images {
              thumbSquare
            }
            adultOnly
            currency
            bookingPaymentPercent
            cardPrices {
              kind
              period
              price
            }
            renterFeeCoefficient
          }
          ... on User {
            id
            publicName
            avatar {
              medium
            }
            proofs {
              emailConfirmed
              hasPaymentMethod
              hasPrivateInfo
              phoneConfirmed
            }
          }
        }
      }
    }
  }
`

export default {
  favoritLotAdd,
  favoritUserAdd,
  favoritLotRemove,
  favoritUserRemove,
  fetchFavoritsLots,
}
